import { cn } from "@/utils/cn";
import { IonModal } from "@ionic/react";
import { memo, useRef } from "react";
import { PrivacyAgreementContent } from "./privacy-content";

interface PolicyProps {
  /** Override the trigger label styling (defaults to the welcome-screen footer style). */
  className?: string;
}

export const Policy = memo(function Policy({ className }: PolicyProps) {
  const modalRef = useRef<HTMLIonModalElement>(null);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    modalRef.current?.present();
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    e.stopPropagation();
    e.preventDefault(); // suppress the synthesized click so the label can't forward it to the checkbox
    modalRef.current?.present();
  };

  return (
    <>
      <span
        onClick={handleClick}
        onTouchEnd={handleTouchEnd}
        className={cn(
          "text-splash-screen-background cursor-pointer p-0 text-[13px] leading-normal font-bold underline hover:opacity-80",
          className,
        )}
      >
        Privacy Policy
      </span>
      <IonModal
        ref={modalRef}
        initialBreakpoint={0.8}
        breakpoints={[0, 0.8, 1]}
        handleBehavior="cycle"
        style={{
          "--border-radius": "56px",
        }}
      >
        <div className="mt-8 overflow-y-auto p-8">
          <PrivacyAgreementContent />
        </div>
      </IonModal>
    </>
  );
});
